// extracted by mini-css-extract-plugin
export default {"field":"SYsMRC","caption":"uhajMr","customCaption":"KUOpOD","disabledCaption":"KmlP5D","input":"oPHsTz","withInput":"MYoo1P","error":"qlQpGN","newError":"E1BgTS","icon":"y9HqX5"};